import { useState, useEffect, useRef } from 'react';

/**
 * This hook is taken from the https://github.com/MomenSherif/react-oauth repo
 */
const useLoadGsiScript = (props) => {
    const {
        onScriptLoadSuccess=f=>f, // Callback fires on load [gsi](https://accounts.google.com/gsi/client) script success
        onScriptLoadError=f=>f  // Callback fires on load [gsi](https://accounts.google.com/gsi/client) script failure
    } = props;

    const [state, setState] = useState({
        scriptLoadedSuccessfully: false,
        isLoading: true,
    });

    const onScriptLoadSuccessRef = useRef(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;

    const onScriptLoadErrorRef = useRef(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;

    useEffect(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.onload = () => {
            setState({scriptLoadedSuccessfully: true, isLoading: false});
            onScriptLoadSuccessRef.current?.();
        };
        scriptTag.onerror = () => {
            setState({scriptLoadedSuccessfully: false, isLoading: false,});
            onScriptLoadErrorRef.current?.();
        };

        document.body.appendChild(scriptTag);

        // Remove the script once unmounted
        return () => {
            document.body.removeChild(scriptTag);
        };
    }, []);

    return state;
}

export default useLoadGsiScript;